import script from "./RejectModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RejectModal.vue?vue&type=script&setup=true&lang=js"

import "./RejectModal.vue?vue&type=style&index=0&id=f8091f84&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8091f84"]])

export default __exports__